import React, { Component } from 'react';
import config from 'react-global-configuration';

import { Link } from 'react-router-dom';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class StaffPaymentsHourTab extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      training_certification_staff_payments_hours: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    
    // this.botaoEditOrderPayment = this.botaoEditOrderPayment.bind(this);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.training_certification_staff_payments_hours)) {
      this.setState({training_certification_staff_payments_hours: newProps.training_certification_staff_payments_hours});
    }
  }

  // botaoEditOrderPayment (cell, row) {
  //   var dados = this.state.training_certification_staff_payments_hours;
  //   var payment_order_id = '';
  //   var code = '';
  //   dados.map(function(dado, index){
  //     if (dado.id == cell) {
  //       payment_order_id = dado.payment_order_id;
  //       code = dado.payment_order_code;
  //     }
  //   });
  //   return (
  //     <Link to={'/ordem/pagamento/editar/' + payment_order_id}> {code}</Link>
  //   );
  // }

  render() {
    return (
<div>
    <BootstrapTable data={this.state.training_certification_staff_payments_hours} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há pagamentos em aberto'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
      <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>
      {/* <TableHeaderColumn dataField="id" dataFormat={this.botaoEditOrderPayment} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Código trein.</TableHeaderColumn> */}
      <TableHeaderColumn dataField="payment_order_code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Código trein.</TableHeaderColumn>
      <TableHeaderColumn dataField="certification_type" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Tipo de trein.</TableHeaderColumn>
      <TableHeaderColumn dataField="certification" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Aula</TableHeaderColumn>
      <TableHeaderColumn dataField="period" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Período</TableHeaderColumn>
      <TableHeaderColumn dataField="training" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Treinamento</TableHeaderColumn>
      <TableHeaderColumn dataField="training_code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nº e Rev.</TableHeaderColumn>
      <TableHeaderColumn dataField="supplier" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Local</TableHeaderColumn>
      <TableHeaderColumn dataField="hours_paid_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Horas pagas</TableHeaderColumn>
      <TableHeaderColumn dataField="hour_value" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Valor da hora</TableHeaderColumn>
      <TableHeaderColumn dataField="hours_total" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Total de horas</TableHeaderColumn>
    </BootstrapTable>
</div>
    );
  }
}

export default StaffPaymentsHourTab;



// WEBPACK FOOTER //
// ./src/Components/SigtripStaffs/Elements/StaffPaymentsHourTab.js